import React, { useState, useEffect } from "react";
import { Divider, Checkbox, Alert } from "antd";

// function isEnabled(allNotifications, notificationType) {
//   if (!allNotifications || allNotifications.length === 0) {
//     return true;
//   }
//   if (allNotifications.includes(notificationType)) {
//     return true;
//   }

//   return false;
// }

function NotificationsTab(props) {
  //console.log(props.url, props.enabledNotifications);
  const initialState = {};
  initialState[props["url"]] = props.enabledNotifications;

  const [enabledNotifications, setEnabledNotifications] = useState(initialState);

  useEffect(() => {
    const newState = {};
    newState[props["url"]] = props.enabledNotifications;
    setEnabledNotifications(state => ({ ...state, ...newState }));
  }, [props]);

  const onChange = checkedValues => {
    const newState = {};
    newState[props["url"]] = checkedValues;

    setEnabledNotifications(state => ({ ...state, ...newState }));
    props.updateNotifications(props.domain, { notifications: checkedValues }, "updateNotifications");
  };

  return (
    <div className="notifications-tab">
      <Alert
        className="disclaimer"
        message="Please note!"
        description={
          <>
            By enabling the notifications below, you confirm that you want to receive email alerts when certain events
            happen on your website:{" "}
            <a href={props.url} target="_blank" rel="noopener noreferrer">
              {props.url}
            </a>
          </>
        }
        type="info"
        showIcon
      />
      {/* <div className="notifications-tab-disclaimer">
        By enabling the notifications below, you confirm that you want to receive email alerts when certain events
        happen on your website:{" "}
        <a href={props.url} target="_blank" rel="noopener noreferrer">
          {props.url}
        </a>
      </div> */}
      {/* <div>{JSON.stringify(enabledNotifications)}</div> */}
      <Checkbox.Group onChange={onChange} value={enabledNotifications[props["url"]]}>
        <div className="notification-container">
          <h4>Ping Uptime</h4>

          <p className="notification-explanation">
            If you'll enable this notification, you'll receive emails when our monitoring tool cannot access your domain
            or when your domain become accessible again after a downtime period.
          </p>
          <Checkbox value={"ping_uptime"}>
            <span className="notification-text">Notify me if your PING Uptime Monitor cannot access my domain</span>
          </Checkbox>
          <Divider />
        </div>

        <div className="notification-container">
          <h4>HTTP Uptime</h4>

          <p className="notification-explanation">
            If you'll enable this notification, you'll receive emails when our monitoring tool doesn't receive an HTTP
            200 status code from your website.
          </p>
          <Checkbox value={"http_uptime"}>
            <span className="notification-text">Notify me if your HTTP Uptime Monitor cannot access my website</span>
          </Checkbox>
          <Divider />
        </div>

        <div className="notification-container">
          <h4>Page Load Timeout</h4>

          <p className="notification-explanation">
            If you'll enable this notification, you'll receive emails when our monitoring tool cannot load your website
            under 20 seconds.
          </p>
          <Checkbox value={"page_load_timeout"}>
            <span className="notification-text">
              Notify me if your HTTP Loading Time Monitor cannot load my website
            </span>
          </Checkbox>
        </div>
      </Checkbox.Group>
    </div>
  );
}

export default NotificationsTab;
